import React from "react";
import { useTranslate } from 'react-redux-multilingual';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Style import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

const  SendCardActionButton = (props) => {
    const t = useTranslate();

    const callback = (abonnementCard) =>{
        props.setAbonnementCard(abonnementCard)
        props.setShowMail(true)
    }

    return (
        <OverlayTrigger
            placement="bottom"
            overlay={
                <Tooltip id={`tooltip-${props.index}`}>
                    {t('sendDocEmail')}
                </Tooltip>
            }
        >
            <span onClick={() => callback(props.abonnementCard)} style={{cursor:'Pointer', color:'#FF8919'}}><FontAwesomeIcon icon={faEnvelope} /></span>
        </OverlayTrigger>  
    )
}

export default SendCardActionButton;